import { css, cx } from "emotion";
import React from "react";
import { handleError } from "../../../components/Utils/Utils";
import TenantService from "../../../Services/TenantService/TenantService";
import PropertyService from "../../../Services/PropertyService";
import { CircularProgress } from "@material-ui/core";

const Profile = (props) => {
  const { isMobile } = props;
  const [loading, setLoading] = React.useState(true);
  const [tenant, setTenant] = React.useState("");

  const getDetailProperty = (id) => {
    PropertyService.getDetail(id)
      .then((response) => {
        setLoading(false);
        let newTenant = tenant;
        newTenant.property = response.data
        setTenant(newTenant);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error);
      });
  };

  const getDetailTenant = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user?.type === "tenant") {
      TenantService.getByID(user?.tenant?.id)
        .then((response) => {
          setTenant(response?.data);
          getDetailProperty(response?.data?.id);
        })
        .catch((error) => {
          setLoading(false);
          handleError(error);
        });
    }
  };

  React.useState(() => {
    getDetailTenant();

    return () => {
      setLoading(true);
      setTenant("");
    };
  }, []);

  return (
    <div
      className={cx(
        css`
          ${isMobile ? "width: 100%" : "width: 400px"}
        `,
        "px-3 py-2"
      )}
    >
      <h2 className="font-20 font-bold">Profile</h2>
      <span className="font-10">
        Untuk mengubah profil, silahkan hubungi pihak manajemen {tenant?.property?.type || ""}.
      </span>
      {!loading && (
        <div className="mt-3">
          <div className="form-group">
            <label className="d-block font-bold font-12">Logo</label>
            <div className="d-flex">
              <img
                src={tenant?.logo?.square}
                style={{ width: 76, height: 76, borderRadius: 6 }}
                alt="logo"
              />
              <p className="font-10 line-height-1 mb-0 py-2 px-3">
                Ukuran logo = 512 x 512 px
                <br />
                Ekstensi file yang diperbolehkan: JPG, JPEG, PNG
              </p>
            </div>
          </div>
          <div className="form-group">
            <label className="d-block font-bold font-12">Nama Toko</label>
            <input
              className="form-control rounded-8px border-0 font-12"
              value={tenant?.name}
              disabled
            />
          </div>
          <div className="form-group">
            <label className="d-block font-bold font-12">Lokasi Mall</label>
            <input
              className="form-control rounded-8px border-0 font-12"
              value={tenant?.property?.name}
              disabled
            />
          </div>
          <div className="form-group">
            <label className="d-block font-bold font-12">Lokasi Toko</label>
            <input
              className="form-control rounded-8px border-0 font-12"
              value={tenant?.location_detail}
              disabled
            />
          </div>
        </div>
      )}
      {(loading) &&
        <div className={cx(css`width: 100%; height: 20vw; display: flex; justify-content: center; align-items: center`,"mt-3")}>
            <CircularProgress />
        </div>
      }
    </div>
  );
};

export default Profile;
